import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { Toaster } from "@/components/ui/sonner";
import { Loader2 } from "lucide-react";
import Layout from "@/components/Layout";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import Aset from "@/pages/it/Aset";
import Jadwal from "@/pages/it/Jadwal";
import Maintenance from "@/pages/it/Maintenance";
import Pengadaan from "@/pages/it/Pengadaan";
import Laporan from "@/pages/it/Laporan";
import Users from "@/pages/it/Users";
import Ruangan from "@/pages/it/Ruangan";
import { LaporanPerbaikan, LaporanMaintenance, LaporanPengadaan, LaporanAset } from "@/pages/pimpinan/LaporanPages";
import ScanAsset from "@/pages/ScanAsset";

function Protected({ roles, children }) {
  const { user } = useAuth();
  if (user === null)
    return (
      <div className="min-h-screen flex items-center justify-center bg-background" data-testid="auth-loading">
        <Loader2 className="w-8 h-8 animate-spin text-primary" />
      </div>
    );
  if (user === false) return <Navigate to="/login" replace />;
  if (roles && !roles.includes(user.role)) return <Navigate to="/dashboard" replace />;
  return children;
}

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/scan/:assetId" element={<ScanAsset />} />
          <Route
            element={
              <Protected>
                <Layout />
              </Protected>
            }
          >
            <Route path="/" element={<Navigate to="/dashboard" replace />} />
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/aset" element={<Protected roles={["it"]}><Aset /></Protected>} />
            <Route path="/jadwal" element={<Protected roles={["it"]}><Jadwal /></Protected>} />
            <Route path="/maintenance" element={<Protected roles={["it"]}><Maintenance /></Protected>} />
            <Route path="/pengadaan" element={<Protected roles={["it"]}><Pengadaan /></Protected>} />
            <Route path="/laporan" element={<Protected roles={["it"]}><Laporan /></Protected>} />
            <Route path="/users" element={<Protected roles={["it"]}><Users /></Protected>} />
            <Route path="/ruangan" element={<Protected roles={["it"]}><Ruangan /></Protected>} />
            <Route path="/laporan/perbaikan" element={<Protected roles={["pimpinan"]}><LaporanPerbaikan /></Protected>} />
            <Route path="/laporan/maintenance" element={<Protected roles={["pimpinan"]}><LaporanMaintenance /></Protected>} />
            <Route path="/laporan/pengadaan" element={<Protected roles={["pimpinan"]}><LaporanPengadaan /></Protected>} />
            <Route path="/laporan/aset" element={<Protected roles={["pimpinan"]}><LaporanAset /></Protected>} />
          </Route>
          <Route path="*" element={<Navigate to="/dashboard" replace />} />
        </Routes>
        <Toaster position="top-right" richColors />
      </BrowserRouter>
    </AuthProvider>
  );
}
